import { Radar } from "react-chartjs-2";
import Page from "src/components/Report/Page";
import MiniChart from "./components/MiniChart";
import { useLocation } from "react-router-dom";

export default function Page20() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");
    let alayeghVaReghbatShoghli;
    if (JSON.parse(localStorage?.data)?.[jobId]?.alayeghVaReghbatShoghli) {
        alayeghVaReghbatShoghli = JSON.parse(localStorage?.data)?.[jobId]?.alayeghVaReghbatShoghli
    } else {
        alayeghVaReghbatShoghli = []
    }


    const options = {
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            r: {
                pointLabels: {
                    font: {
                        size: "14px",
                        family: "iransans",
                        weight: "900"
                    }, // Adjust the font size as desired
                }
            },
            // suggestedMin: 2, // Define the minimum value for the chart
            // suggestedMax: 5,
        },
    };

    let labels = [];
    let labelsData = [];
    if (JSON.parse(localStorage?.data)?.[jobId] && JSON.parse(localStorage?.data)?.[jobId]?.alayeghVaReghbatShoghli) {
        alayeghVaReghbatShoghli = JSON.parse(localStorage?.data)?.[jobId]?.alayeghVaReghbatShoghli;
        Object.keys(alayeghVaReghbatShoghli).map((key, index) => {
            if (alayeghVaReghbatShoghli[key].value >= 0) {
                if (key.substring(0, 40) == key) {
                    labels.push(key);
                } else {
                    labels.push(key.substring(0, 40) + "...");
                }
                labelsData.push(alayeghVaReghbatShoghli[key].value);
            }
        })
    }

    const data = {
        labels: labels,
        datasets: [
            {
                data: labelsData,
                backgroundColor: '#f9b30244',
                borderColor: '#f9b302',
                borderWidth: 1,
            },
        ],
    };

    return (
        <Page pageNumber={20}>
            <div className="font-bold text-lg">
                علایق و رغبت شغلی
            </div>
            <div className="flex justify-center items-center m-auto w-[500px]">
                <Radar data={data} options={options} />
            </div>
            <div className="flex flex-col">

                {
                    Object.keys(alayeghVaReghbatShoghli).sort(function (a, b) { return alayeghVaReghbatShoghli[b].value - alayeghVaReghbatShoghli[a].value }).map((key, index) => {
                        if (alayeghVaReghbatShoghli[key].value >= 0) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <MiniChart value={alayeghVaReghbatShoghli[key].value} height={50} />
                                    <div className="max-w-[120px] min-w-[120px] w-[120px] border-x-2 px-2">{key}</div>
                                    <div className="text-[13px]">{alayeghVaReghbatShoghli[key].desc}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
            <p className="rounded-lg p-4 text-justify">
                همانطور که مشخص است در این شغل افرادی که از ‌
                <span className="text-gray-800">
                    {alayeghVaReghbatShoghli &&
                        Object.keys(alayeghVaReghbatShoghli).sort(function (a, b) { return alayeghVaReghbatShoghli[b].value - alayeghVaReghbatShoghli[a].value }).map((key, index) => {
                            if (index < 3) {
                                return (key) + "، "
                            }
                        })}
                </span>
                بالایی برخوردارند موفق‌ترند.
                {/* <span className="text-gray-800">
                    {alayeghVaReghbatShoghli &&
                        Object.keys(alayeghVaReghbatShoghli).sort(function (a, b) { return alayeghVaReghbatShoghli[a].value - alayeghVaReghbatShoghli[b].value }).map((key, index) => {
                            if (index < 2) {
                                return (key) + "، "
                            }
                        })}
                </span>
                از شانس موفقیت کمتری برخوردارند */}
            </p>
        </Page>
    )
}